module.exports = __webpack_public_path__ + "static/media/flexplay_logo_bnw.5751b570.png";